import { Component, OnInit, ViewChild, DebugNode } from '@angular/core';
import { StudentregistrationService } from './studentregistration.service';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService, NgxSpinnerComponent } from 'ngx-spinner';
import { HttpErrorResponse } from '@angular/common/http';
import { global } from '../../shared/global';
import { Router, ActivatedRoute } from "@angular/router";
import { StudentRegistration } from '../Models/studentregistration.model';
//import { CaptchaComponent } from 'angular-captcha';

declare var $: any;

@Component({
  selector: 'app-studentregistration',
  templateUrl: './studentregistration.component.html',
  styleUrls: ['./studentregistration.component.css']
})
export class StudentregistrationComponent implements OnInit {
  @ViewChild('studentForm') studentForm: NgForm;
  //@ViewChild(CaptchaComponent) captchaComponent: CaptchaComponent;
  data: StudentRegistration;
  dropDownData: any;
  responseData: any;
  isDesc: boolean;
  errorMessages: string;
  column: string;
  p: number = 1;
  pageLimit = global.pageLimit;
  submitted: boolean;
  searchtext: any;
  HashCode: any;
  boards: any;
  stds: any;
  states: any;
  cities: any;
  schools: any;
  areas: any;
  categories: any;
  stateID: any;
  area: any;
  schoolname: any;
  address: any;
  schoolcode: any;
  mobno: any;
  mailid: any;
  city: any;
  state: any;
  pincode: any;
  cityid: any;
  btnsubmittext = "Submit";
  totalPages = 10;
  totalCollege: any;

  constructor(private service: StudentregistrationService, private toastr: ToastrService, private spinner: NgxSpinnerService, private router: Router, private rout: ActivatedRoute) { }

  ngOnInit(): void {
    // if(this.router.url != "/studentregistration"){
    //   this.router.navigate(['/studentregistration']);
    // }
    this.data = new StudentRegistration();
    //console.log(this.captchaComponent);
    // this.captchaComponent.captchaEndpoint = 
    // global.baseAPIUrl+'simple-captcha-endpoint.ashx';
    //this.captchaComponent.captchaEndpoint = 'simple-captcha-endpoint.ashx';
    this.fillState();
    this.fillBoard();
    this.fillStandard();
    this.fillSchoolCategory();
    this.cityid = 0;

  }

  // validate(value, valid): void {

  //   // get the user-entered captcha code value to be validated at the backend side        
  //   var userEnteredCaptchaCode = this.captchaComponent.userEnteredCaptchaCode;

  //   // get the id of a captcha instance that the user tried to solve
  //   var captchaId = this.captchaComponent.captchaId;

  //   const postData = {
  //     // add the user-entered captcha code value to the post data    
  //     userEnteredCaptchaCode: userEnteredCaptchaCode,
  //     // add the id of a captcha instance to the post data      
  //     captchaId: captchaId
  //   };

  //   // post the captcha data to the backend
  //   this.service.sendCaptcha(postData)
  //     .subscribe(data => {
  //       this.responseData = data;
  //       this.spinner.hide();
  //       if (this.responseData.status == false) {
  //         this.toastr.error(this.responseData.message);
  //         return
  //       } else {
  //         // captcha validation succeeded; proceed with the workflow
  //        alert("hiii");
  //       }
  //     },
  //       error => {
  //         throw new Error(error);
  //       });
  // }

  fillBoard() {
    const data = {
      schoolID : this.data.SchoolID
    };
    this.service.fillBoard(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.boards = this.dropDownData.dropdownlist;
        this.data.BoardID = 0;
      });
  }

  fillStandard() {
    const data = {
    };
    this.service.fillStandard(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.stds = this.dropDownData.dropdownlist;
        this.data.STDID = 0;
      });
  }

  fillSchoolCategory() {
    const data = {
    };
    this.service.fillSchoolCategory(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.categories = this.dropDownData.dropdownlist;
        this.data.CategoryID = 0;
      });
  }

  fillSchoolName(state, city, area) {
    const data = {
      stateID: state,
      cityID: city,
      area: area
    };
    this.service.fillSchoolName(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.schools = this.dropDownData.dropdownlist;
        if(this.data.SchoolID == 0 || this.data.SchoolID == undefined){
          this.data.SchoolID = 0;
        }
      });
  }

  fillSchoolArea(state, city) {
    const data = {
      stateID: state,
      cityID: city
    };
    this.service.fillSchoolArea(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.areas = this.dropDownData.dropdownlist;
        if(this.data.Area == '' || this.data.Area == undefined){
          this.data.Area = 'Select';
        }
        //this.boards.splice(0, 1);
      });
  }

  fillState() {
    const data = {
    };
    this.service.fillState(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.states = this.dropDownData.dropdownlist;
        this.data.StateID = 12;
        this.fillCity(this.data.StateID);
      });
  }

  fillCity(state) {
    const data = {
      stateID: state
    };

    this.service.fillCity(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.cities = this.dropDownData.dropdownlist;
        if(this.data.CityID == 0 || this.data.CityID == undefined){
          this.data.CityID = 0;
        }
      });
  }

  onSubmit(data) {
    this.submitted = true;
    if ((this.data.BoardID == 0 || this.data.BoardID == undefined) || (this.data.STDID == 0 || this.data.STDID == undefined) ||
      (this.data.CategoryID == 0 || this.data.CategoryID == undefined) || (this.data.SchoolID == 0 || this.data.SchoolID == undefined)
      || (this.data.Area == 'Select' || this.data.Area == undefined)) {
      return;
    }
    if (this.studentForm.valid) {
      this.spinner.show();
      this.service.saveStudent(this.data)
        .subscribe(data => {
          this.responseData = data;
          this.spinner.hide();

          if (this.responseData.status == false) {
            this.toastr.error(this.responseData.message);
            return
          }
          else {
            this.toastr.success(this.responseData.message);
            this.resetForm();
          }
        }, (err: HttpErrorResponse) => {
          localStorage.clear();
          this.spinner.hide();
          this.toastr.error('Something Went Wrong');
          this.router.navigate(['/studentregistration']);
        });
    }
  }
  getSchooltByHashcode(schoolid) {

    var RegNo = $("#SchoolID").val();
    if (schoolid == 0 || schoolid == undefined) {
      this.toastr.error("Select School");
      return;
    }
    else {
      const data = {
        SchoolID: schoolid
      };
      this.spinner.show();
      this.service.getSchooltByHashcode(data)
        .subscribe(data => {
          this.responseData = data;
          this.spinner.hide();
          if (this.responseData.status == false) {
            this.toastr.error(this.responseData.message);
            return
          }
          else {
            this.spinner.hide();
            //this.fillCity();
            //this.data = this.responseData;

            this.state = this.responseData.State;
            this.city = this.responseData.City;
            this.schoolcode = this.responseData.UdiseNo;
            this.area = this.responseData.Area;
            this.address = this.responseData.Address;
            this.mobno = this.responseData.MobileNo;
            this.mailid = this.responseData.MailID;
            this.pincode = this.responseData.Pincode;
            this.data.CityID = this.responseData.CityID;
            this.data.StateID = this.responseData.StateID;
            this.data.Area = this.responseData.Area;
            this.data.SchoolID = this.responseData.SchoolID;
            this.fillBoard();

            // this.fillStandard();
            // this.fillSchoolCategory();

            // $('#StateID').prop("disabled", true);
            // $('#CityID').prop("disabled", true);
            // $('#Area').prop("disabled", true);
            // $('#SchoolID').prop("disabled", true);
            this.btnsubmittext = "Submit";
          }
        }, (err: HttpErrorResponse) => {
          localStorage.clear();
          this.spinner.hide();
          this.toastr.error('Something Went Wrong');
          this.router.navigate(['/studentregistration']);
        });
    }
  }

  getStudentByHashcode() {
    var RegNo = $("#RegistrationNo").val();
    if (RegNo == 0 || RegNo == undefined) {
      this.toastr.error("Enter registration no");
      return;
    }
    else {
      const data = {
        HashCode: RegNo
      };
      this.spinner.show();
      this.service.getStudentByHashcode(data)
        .subscribe(data => {
          this.responseData = data;
          this.spinner.hide();
          if (this.responseData.status == false) {
            this.toastr.error(this.responseData.message);
            return
          }
          else {
            this.spinner.hide();
            //this.fillCity();
            this.data = this.responseData;
            this.data.BoardID = this.responseData.BoardID;
            this.data.STDID = this.responseData.STDID;
            this.data.CategoryID = this.responseData.CategoryID;
            // this.state = this.responseData.State;
            // this.city = this.responseData.City;
            // this.schoolcode = this.responseData.UdiseNo;
            this.area = this.responseData.Area;
            this.schoolname = this.responseData.SchoolID;
            this.cityid = this.responseData.CityID;
            // this.address = this.responseData.Address;
            // this.mobno = this.responseData.MobileNo;
            // this.mailid = this.responseData.MailID;
            // this.pincode = this.responseData.Pincode;


            // this.data.StateID = this.responseData.StateID;
            // this.data.Area = this.responseData.Area;


            setTimeout(() => {
              this.getSchooltByHashcode(this.responseData.SchoolID);
              this.fillCity(this.responseData.StateID);
              this.fillSchoolArea(this.responseData.StateID, this.cityid);
              // this.fillSchoolName(this.responseData.StateID, this.cityid, this.area);
            }, 1000);
            setTimeout(() => {
              this.fillSchoolName(this.responseData.StateID, this.cityid, this.area);
            }, 1000);
            this.data.StateID = this.responseData.StateID;
            this.data.CityID = this.cityid;
            this.data.Area = this.area;
            this.data.SchoolID = this.schoolname;


            // this.data.Area = area;
            // this.data.SchoolID = schlid;
            // $('#StateID').prop("disabled", true);
            // $('#CityID').prop("disabled", true);
            // $('#Area').prop("disabled", true);
            // $('#SchoolID').prop("disabled", true);
            this.btnsubmittext = "Submit";
          }
        }, (err: HttpErrorResponse) => {
          localStorage.clear();
          this.spinner.hide();
          this.toastr.error('Something Went Wrong');
          this.router.navigate(['/studentregistration']);
        });
    }
  }

  openpopupRegisteration() {
    $("#RegistrationNo").val('');
    this.resetForm();
    this.studentForm.resetForm();
  }
  resetForm() {
    //$("#RegistrationNo").val('');
    this.data.ID = 0;
    this.data.HashCode = null;
    this.data.SchoolID = 0;
    this.data.BoardID = 0;
    this.data.MailID = null;
    this.data.STDID = 0;
    this.data.CategoryID = 0;
    this.data.MobileNo = null;
    this.data.StateID = 0;
    this.data.Area = 'Select';
    this.data.CityID = 0;
    this.data.StateID = 12;
    this.data.StudName = null;
    this.data.FatherName = null;
    this.data.FatherMobile = null;
    this.data.FatherMail = null;
    this.data.MotherName = null;
    this.data.MotherMobile = null;
    this.data.MotherMail = null;
    this.state = null;
    this.city = null;
    this.schoolcode = null;
    this.area = null;
    this.address = null;
    this.mobno = null;
    this.mailid = null;
    this.pincode = null;
    this.submitted = false;
    this.studentForm.resetForm();
    this.btnsubmittext = "Submit";
  }
}
